import { render, staticRenderFns } from "./endorse-payment.vue?vue&type=template&id=c4ca4b44&scoped=true&"
import script from "./endorse-payment.vue?vue&type=script&lang=js&"
export * from "./endorse-payment.vue?vue&type=script&lang=js&"
import style0 from "./endorse-payment.vue?vue&type=style&index=0&id=c4ca4b44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ca4b44",
  null
  
)

export default component.exports